
<div class="page OrDetails">
  <a backButton
     class="OrDetails__BackLink">
    <i class="fas fa-chevron-left"></i>
    {{ 'common.back' | translate }}
  </a>
  <div class="OrDetails__Header">
    <span>
       {{ 'store.redemptions.details.title' | translate }}
    </span>
    <div>
    </div>
  </div>
  <div class="OrDetails__MainContainer">
    <div class="OrDetails__SubContainer">
      <div class="OrDetails__Img">
        <img [src]="order?.storeLogoUrl" alt="LOGO">
        <div class="OrDetails__ImgTitle">
          {{order?.title}}
        </div>
        <div class="OrDetails__ImgSubTitle">
          {{ 'store.orders.details.status' | translate }}:
          <div *ngIf="order.status === 'ACTIVE'" style="margin-right: auto; margin-left: auto" [class]="'PURCHASED'">{{ 'store.orders.status.purchased' | translate }}</div>
          <div  *ngIf="order.status !== 'ACTIVE'" style="margin-right: auto; margin-left: auto" [class]="order.status">{{order?.status}}</div>
        </div>
      </div>
    </div>
    <div class="details-container">
      <div class="bar-code-container">
        <qrcode [qrdata]="storeQrcode"  [width]="100" [errorCorrectionLevel]="'M'"></qrcode>

        <div>
          {{order?.code}}
        </div>
      </div>
      <div class="second-container">
        <div class="purchase-cont">
          <div>
            <div class="label">{{ 'store.orders.table.purchasedBy' | translate }}:</div>
            <div class="value">{{order?.purchasedBy}}</div>
            <!--          <div class="label" style="color: rgba(75, 95, 120, 1);">({{order?.user?.phoneNumber}})</div>-->
          </div>
          <!--        <div>-->
          <!--          <div class="label">Purchased date:</div>-->
          <!--          <div  class="value"><span class="ltr-text">{{order?.createdDate  | date:'hh:mm, dd LLL,yyyy'  }}</span></div>-->
          <!--        </div>-->
        </div>

        <!--      <div class="label">Redemption date:</div>-->
        <!--      <div  class="value" *ngIf="order?.codeStatus != 'ACTIVE'"><span class="ltr-text">{{order?.updatedDate | date: 'hh:mm, dd LLL,yyyy'}}</span></div>-->
        <!--      <div class="value" *ngIf="order?.codeStatus == 'ACTIVE'">.,.</div>-->


      </div>
      <div class="second-container">
        <div class="purchase-cont">
          <div>
            <div class="label">{{ 'store.orders.table.voucherValue' | translate }}:</div>
            <div  class="value"><span class="ltr-text">{{order?.voucherValue  | currency:order?.currency?.code : 'code'}}</span></div>
          </div>
          <div>
            <div class="label">{{ 'common.fee' | translate }}:</div>
            <div  class="value" *ngIf="order?.codeStatus != 'ACTIVE'"><span class="ltr-text">{{order.fee  | currency:order?.currency?.code : 'code'}}</span></div>
            <div class="value" *ngIf="order?.codeStatus == 'ACTIVE'">.,.</div>
          </div>
          <div>
            <div class="label">{{ 'store.orders.details.voucherPrice' | translate }}:</div>
            <div  class="value"><span class="ltr-text">{{order?.price  | currency:order?.currency?.code : 'code'}}</span></div>
          </div>
          <div>
            <div class="label">{{ 'store.orders.details.totalAmount' | translate }}:</div>
            <div class="value" *ngIf="order?.codeStatus == 'ACTIVE'">.,.</div>
            <input class="value"  *ngIf="order?.codeStatus != 'ACTIVE'" style="width: 100%" disabled type="text" value="{{order?.total| currency:order?.currency?.code : 'code'}}">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ngx-spinner color="rgba(30, 205, 100, 1)" type="ball-scale-multiple"></ngx-spinner>
